import axios from 'axios'
import GlobalPrefsService from "./globalPrefsService"
import {PREFS_UNITS_TYPE} from '../components/globalPrefs/GlobalPrefsDialog'

export default {
    
    isIE() {
        let UA = window.navigator.userAgent.toLowerCase()
        return UA && /msie|trident/.test(UA)
    },
    isEdge() {
        let UA = window.navigator.userAgent.toLowerCase()
        return UA && /edge/.test(UA)
    },

    getFilterValues(url, filterValuesArray) {
        return axios({
            url: url,
            method: 'POST',
            data: filterValuesArray
        }).then(response => {
            return response.data
        }).catch(error => {
            console.error(url + ' getFilterValues error:', error.response ? error.response : error)
            return Promise.reject(error)
        })
    },
    // Replaces the string template variable {value} with respective property from the variablesObj (String interpolation)
    // ex: some/path/{replaceMe}/and/other/path, {replaceMe: "some-text"}    
    createStringFromTemplate(template, variablesObj) {
        return template.replace(new RegExp("\{([^\{]+)\}", "g"), function(_matchResult, prop){
            return variablesObj[prop];
        });
    },

    checkForWarningMessage (results)
    {
        if (results && results.messages)
        {
            let msgList = []
            results.messages.forEach (message => {
                if (message.type === 'WARNING')
                {
                    msgList.push (message.text)
                }
            })
            return (msgList)
        }
        return ('')
    },
    /**
     * Convert from a given value and units to the units given my the global user preferences
     * @param fromTemp - temperature value integer
     * @param fromTempUnits - units the fromTemp is in, PREFS_UNIT_TYPE.METRIC or PREFS_UNIT_TYPE.IMPERIAL
     * @returns {number|*} the converted temperature
     */
    convertTemperature (fromTemp, fromTempUnits)
    {
        // If the conversion units match user prefs, nothing to do
        if ((GlobalPrefsService.getUnitsType() === fromTempUnits) ||
            (fromTemp === null))
        {
            return fromTemp
        }
        // else they are not the same so if they want to see Celsius, do the math
        else if (GlobalPrefsService.getUnitsType() === PREFS_UNITS_TYPE.METRIC)
        {
            return ((fromTemp - 32) / 1.8)
        }
        // else they are not the same so if they want to see Fahrenheit, do the math
        else
        {
            return (fromTemp * 1.8 + 32)
        }
    },
}
